import { Package } from 'lucide-react'
import { PageHeader } from '@/components/shared/PageHeader'
import { EmptyState } from '@/components/shared/EmptyState'

interface CatalogoPageProps {
  variant?: 'roles' | 'assets'
}

export function CatalogoPage({ variant = 'roles' }: CatalogoPageProps) {
  const isRoles = variant === 'roles'
  return (
    <div className="space-y-6">
      <PageHeader
        title={isRoles ? 'Catálogo de Roles' : 'Catálogo de Assets'}
        description={
          isRoles
            ? 'Roles disponibles en la plataforma Kashio.'
            : 'Assets y recursos disponibles en la plataforma.'
        }
      />
      <EmptyState
        icon={<Package size={24} />}
        title="Próximamente"
        description="Esta sección es exclusiva para empleados Kashio."
      />
    </div>
  )
}
